import { css } from "@compiled/react";

import { SocialShareMenu } from "./social-share-menu";

export type ArticleShareProps = {
    description?: string | null;
    link?: string | null;
    title?: string | null;
    source?: string | null;
};

const ArticleShareContainerStyle = css({
    display: "flex",
    backgroundColor: "#fff",
    minHeight: "74px",
    flexWrap: "wrap",
    verticalAlign: "baseline"
});

const ColumnStyles = css({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    float: "left",
    padding: "0 20px 0 20px",
    position: "relative",
    margin: "auto"
});

export const ArticleShare = ({
    description,
    link,
    title,
    source
}: ArticleShareProps) => {
    return (
        <div css={ArticleShareContainerStyle}>
            <div css={ColumnStyles}>
                {description && link && title && (
                    <SocialShareMenu
                        description={description}
                        link={link}
                        title={title}
                        source={source}
                    />
                )}
            </div>
        </div>
    );
};
